<template>
	<BaseSidebar title="Nearby Locks" @close="$emit('close')">
		<!-- lock list -->
		<v-list class="access-list">
			<template v-for="(deviceId, i) in locks">
				<v-list-item
					:key="i"
					:disabled="loading.locks"
					@click="selectLock(deviceId)"
				>
					<v-list-item-title>{{ deviceId }}</v-list-item-title>
					<v-list-item-action v-if="form.deviceId === deviceId"
						><v-icon color="ocean lighten-2"
							>fas fa-bullseye</v-icon
						></v-list-item-action
					>
				</v-list-item>
				<v-divider :key="'divider-' + i" />
			</template>
		</v-list>
		<div class="search-again text-end">
			<v-btn
				tile
				text
				height="20"
				color="ocean"
				:loading="loading.locks"
				:disabled="loading.locks"
				@click="getNearbyLocks"
			>
				Search Again
				<template #loader>
					<span>Searching...</span>
				</template>
			</v-btn>
		</div>

		<!-- add lock -->
		<template #actions>
			<v-form autocomplete="off" @submit.prevent="submitLock">
				<v-card-title class="pt-0">Register Lock</v-card-title>
				<v-card-text class="pb-0">
					<v-text-field
						dense
						label="Lock (Select from above)"
						:value="form.deviceId"
						disabled
					/>
					<v-text-field v-model="form.roomName" dense label="Name" />
					<v-text-field
						v-model="form.pinCode"
						dense
						label="Master Code"
						:type="showPassword ? 'text' : 'password'"
						autocomplete="off"
					>
						<template #append>
							<div style="width: 30px; text-align: center">
								<v-icon
									@mousedown="handleShowPassword"
									@touchstart="handleShowPassword"
									>{{
										showPassword ? "fas fa-eye" : "fas fa-eye-slash"
									}}</v-icon
								>
							</div>
						</template>
					</v-text-field>
				</v-card-text>
				<v-card-actions>
					<div class="d-flex flex-grow-1 justify-center">
						<span class="grey--text" v-text="loading.registerText" />
					</div>
					<v-btn
						outlined
						tile
						color="ocean"
						:loading="loading.register"
						:disabled="!formFilled"
						type="submit"
					>
						{{ submitFailed ? "Try Again" : "Save" }}
					</v-btn>
				</v-card-actions>
			</v-form>
		</template>
	</BaseSidebar>
</template>

<script>
import _ from "lodash";
import BaseSidebar from "./Base.vue";
import { mapGetters, mapActions } from "vuex";

export default {
	components: {
		BaseSidebar,
	},

	data() {
		return {
			form: {
				deviceId: null,
				roomName: null,
				pinCode: null,
			},
			showPassword: false,
			loading: {
				locks: false,
				register: false,
				registerText: "",
			},
			submitFailed: false,
		};
	},

	computed: {
		...mapGetters({
			locks: "locks/locks",
		}),

		formFilled() {
			return _.every(this.form);
		},
	},

	watch: {
		"loading.locks"() {
			this.selectLock(null);
		},
	},

	created() {
		this.getNearbyLocks();
	},

	methods: {
		...mapActions({
			getLocks: "locks/getNearbyLocks",
			getRooms: "locks/getRooms",
			pairLock: "locks/pairLock",
			registerLock: "locks/registerLock",
		}),

		async getNearbyLocks() {
			this.loading.locks = true;
			await this.getLocks();
			this.loading.locks = false;
		},

		selectLock(deviceId) {
			this.form.deviceId = deviceId;
		},

		handleShowPassword() {
			this.showPassword = true;
			const hidePassword = () => {
				this.showPassword = false;
				document.removeEventListener("mouseup", hidePassword);
				document.removeEventListener("touchend", hidePassword);
			};
			document.addEventListener("mouseup", hidePassword);
			document.addEventListener("touchend", hidePassword);
		},

		async submitLock() {
			if (this.loading.register) return;
			// TODO validate form
			this.submitFailed = false;
			this.loading.register = true;

			

			try {
				this.loading.registerText = "Pairing lock...";
				await this.pairLock(this.form);
			} catch (e) {
				this.loading.registerText = `Error pairing lock. ${e.message}`;
				this.loading.register = false;
				this.submitFailed = true;
				throw e;
			}

			try {
				this.loading.registerText = "Registering lock...";
				await this.registerLock(this.form);
				this.loading.registerText = "Success!";
				this.resetForm();
				setTimeout(() => (this.loading.registerText = ""), 2000);
			} catch (e) {
				this.loading.registerText = "Failed to register lock.";
				this.submitFailed = true;
				throw e;
			} finally {
				this.loading.register = false;
				this.getRooms();
			}
		},

		resetForm() {
			this.form.roomName = null;
			this.form.pinCode = null;
			this.form.deviceId = null;
			this.getNearbyLocks();
		},
	},
};
</script>

<style lang="scss" scoped>
.access-list {
	border: 1px solid #0006;
	height: 200px;
	overflow-y: auto;

	> :last-child {
		display: none;
	}
}
</style>
